module.exports = __webpack_public_path__ + "static/media/touch-info.67a844e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/touch-info.png
// module id = 375
// module chunks = 0